<template>
    <div class="statusvideo">
        <div class="status_and_info">
            <span class="statusvideo_text" :class="colorstatus">                
                {{textstatus ? textstatus : status_name}}
            </span>                        
        </div>
    </div>
</template>

<script>

import axios from "axios";
import {bus} from "../bus";

export default {
    props: [
        'v_id', 
        'status', 
        'statuses',
        'status_name'
    ],
    data(){
        return{
            video_id: Number(this.v_id),
            status_id: this.status,
            arhiv_component_status: this.status,
            textstatus: '',
            colorstatus: '',
            analize: false,
            persons: [],
            statuseslist: this.statuses
        }
    },
    methods: {
        setConfigStatus(){

            this.getStatusNameById(this.status_id);

            if(this.status_id === null){
                this.textstatus = 'Not analyzed';
                this.colorstatus = '';
            }

            if(this.status_id === 1){
                // this.textstatus = 'IN PROGRESS';
                this.colorstatus = 'grey';
                this.analize = true;
            }

            if(this.status_id === 2){
                // this.textstatus = 'IN PROGRESS';
                this.colorstatus = 'grey';
                this.analize = true;
            }

            if(this.status_id === 4){
                this.colorstatus = 'green';
            }

            if(this.status_id === 5){
                // this.textstatus = 'FAILED'
                this.colorstatus = 'red';
            }

            if(this.status_id === 6){
                // this.textstatus = 'DELETE'
                this.colorstatus = 'red';
            }

        },
        getStatusNameById(id){
            this.statuseslist.map((item) => {
                if(item.id === id){
                    this.textstatus = item.status;
                }
            });
        },
        getStatusIdByName(name){
            if (!name) return;
            const want = String(name).toUpperCase();
            this.statuseslist.map((item) => {
                if(String(item.status).toUpperCase() === want){
                    this.status_id = item.id;
                }
            });
        },
        analizeSend(id){
            if(id){
                this.analize = true;                
                this.setConfigStatus();
            }else{
                this.analize = false;
                axios.post(
                    '/videos/stopvideo',
                    {
                        video_id: this.video_id
                    }
                ).then((responce)=>{
                    console.log( responce.data );
                }).catch(function(){
                    console.log('FAILURE!!');
                });
                this.setConfigStatus();
            }
            axios.post(
                '/videos/analize',
                {
                    video_id: this.video_id
                }
            ).then((responce)=>{
                this.getStatusSdk();
                if( responce.data.status_id ){
                    this.status_id = responce.data.status_id;
                }
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        reanalizeSend(id){
            if(id){
                this.analize = true;                
                this.setConfigStatus();
            }else{
                this.analize = false;
                axios.post('/videos/reanalizevideo',
                    {
                        video_id: this.video_id
                    }
                ).then((responce)=>{
                    console.log( responce.data );
                }).catch(function(){
                    console.log('FAILURE!!');
                });
                this.setConfigStatus();
            }
            axios.post('/videos/analize',
                {
                    video_id: this.video_id
                }
            ).then((responce)=>{
                this.getStatusSdk();
                if( responce.data.status_id ){
                    this.status_id = responce.data.status_id;
                }
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        getStatusSdk(){
            axios.post('/videos/getstatussdk',
                {
                    video_id: this.video_id
                }
            ).then((responce)=>{
                const sdkStatus = (responce.data && responce.data.status) || '';
                const sdkKey = String(sdkStatus).toLowerCase();
                const sdkMap = { proc: 1, wait: 2, stop: 3, done: 4, wrong: 5 };

                this.getStatusIdByName(sdkStatus);
                this.video_id = responce.data.video_id || this.video_id;

                // SDK truth wins over stale local WAIT/PROC (STOP+WRONG fix)
                if (sdkMap[sdkKey]) {
                    this.status_id = sdkMap[sdkKey];
                }
                const lid = responce.data.laravel_status_id;
                if (lid && sdkMap[sdkKey]) {
                    // Prefer mapped SDK id; laravel_status_id only if consistent
                    if (Number(lid) === sdkMap[sdkKey]) {
                        this.status_id = Number(lid);
                    } else {
                        this.status_id = sdkMap[sdkKey];
                    }
                } else if (lid && !sdkKey) {
                    this.status_id = Number(lid);
                }

                this.textstatus = String(sdkStatus).toUpperCase();
                this.setConfigStatus();
                // Keep badge text from SDK (setConfigStatus may overwrite from id)
                if (sdkStatus) {
                    this.textstatus = String(sdkStatus).toUpperCase();
                }

                bus.$emit('camera_sdk_status', {
                    camera_id: this.video_id,
                    status_id: this.status_id,
                    status: sdkStatus,
                    description: responce.data.description || responce.data.desc || null,
                });

                if(sdkKey === 'wait' || sdkKey === 'proc'){
                    setTimeout(() => {
                        this.getStatusSdk();
                    }, 3000);
                }

            }).catch(function(){
                console.log('FAILURE!!');
            });

        },
        setStatus(){
            axios.post('/videos/setstatus',
                {
                    status_id: this.status_id,
                    video_id: this.video_id,
                }
            ).then( (responce) => {


            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        init(){
            this.setConfigStatus();
            console.log('this.status_id', this.status_id);

            // let myTimer = null;
            //
            if(this.status_id === 1 || this.status_id === 2){
                this.getStatusSdk();
            }
            // if(this.status_id === 'done'){
            //     clearInterval(myTimer);
            // }
            bus.$on('analyze_group', (data) => {
                if(data === this.v_id){
                    console.log('analyze_data', data);
                }
            });
            // bus.$on('update_status', (data) => {
            //     console.log('Event update status!');
            // });    
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        status(newStatus, oldStatus) {
            this.status_id = this.status;
            this.init();
        }
    }
}
</script>

<style lang="scss" scoped>
.status_and_info{
    min-width: 200px;
    display: flex;
    .statusvideo_text{
        min-width: 50px;
        text-align: center;
    }
}
.statusvideo{
    display: flex;
    align-items: center;
    .statusvideo_text{
        padding: 4px 8px;
        border-radius: 4px;
        color: var(--color-greylight);
        margin-right: 1rem;
        text-transform: uppercase;
        &.grey{
            background: #828282;
            color: #fff;
        }
        &.green{
            background: #219653;
            color: #fff;
        }
        &.blue{
            background: #3D9EFF;
            color: #fff;
        }
        &.red{
            background: #EB5757;
            color: #fff;
        }
    }
    .statusvideo_presons{
        margin-right: 1rem;
        display: flex;
        align-items: center;
        .statusvideo_presons_link{
            color: #fff;
        }
        .statusvideo_presons_load{
            display: block;
            width: 22px;
            height: 22px;
            border: 2px solid var(--color-blue);
            border-radius: 30px;
        }
    }
}
</style>
